import React from 'react';
import Hr from '../../atoms/Hr/Hr';
import type { ActionDropdownProps } from './types';

/**
 * ActionDropdown — v2 molecule.
 *
 * Acción de pie de un dropdown (p. ej. "Ver más"), separada del contenido por
 * un `Hr`. Migración TypeScript directa del v1; ahora el disparador es un
 * `<button>` nativo (antes un `<div>` con `onClick`), accesible con teclado y
 * lectores de pantalla. No forma parte de ningún patrón `menu`.
 */
function ActionDropdown({ onClick = () => {}, text }: Readonly<ActionDropdownProps>): JSX.Element {
  return (
    <div className="action-dropdown">
      <Hr />
      <button className="action-text__container" onClick={onClick} type="button">
        <span className="action-text__text">{text}</span>
      </button>
    </div>
  );
}

export default ActionDropdown;
